// extracted by mini-css-extract-plugin
module.exports = {"button":"_2787e5dfdf--button--gs5R_","loading":"_2787e5dfdf--loading--fC43r","spinner":"_2787e5dfdf--spinner--rWSqM"};